import { WISHLIST_WIDGET_NAMES } from "@/constants/widget-names";
import { defineModule } from "@modules/dynamic_import/utils/defineModule";

export const AddToWishlistButtonWidgetDefinition = defineModule({
    name: WISHLIST_WIDGET_NAMES.ADD_TO_WISHLIST_BUTTON_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "AddToWishlistButtonWidget" */ "./widgets/add_to_wishlist_button_widget/AddToWishlistButtonWidget"
        ),
});

export const AddToWishlistProductCardWidgetDefinition = defineModule({
    name: WISHLIST_WIDGET_NAMES.ADD_TO_WISHLIST_PRODUCT_CARD_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "AddToWishlistProductCardWidget" */ "./widgets/add_to_wishlist_product_card_widget/AddToWishlistProductCardWidget"
        ),
});

export const AddToWishlistProductPageWidgetDefinition = defineModule({
    name: WISHLIST_WIDGET_NAMES.ADD_TO_WISHLIST_PRODUCT_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "AddToWishlistProductPageWidget" */ "./widgets/add_to_wishlist_product_page_widget/AddToWishlistProductPageWidget"
        ),
});

export const GoToWishlistPageHeaderWidgetDefinition = defineModule({
    name: WISHLIST_WIDGET_NAMES.GO_TO_WISHLIST_PAGE_HEADER_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "GoToWishlistPageHeaderWidget" */ "./widgets/go_to_wishlist_page_header_widget/GoToWishlistPageHeaderWidget"
        ),
});

export const SaveWishlistModalWidgetDefinition = defineModule({
    name: WISHLIST_WIDGET_NAMES.SAVE_WISHLIST_MODAL_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "SaveWishlistModalWidget" */ "./widgets/save_wishlist_modal_widget/SaveWishlistModalWidget"
        ),
});

export const WishlistsManageApproversModalWidgetDefinition = defineModule({
    name: WISHLIST_WIDGET_NAMES.WISHLISTS_MANAGE_APPROVERS_MODAL_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "WishlistsManageApproversModalWidget" */ "./widgets/wishlists_manage_approvers_modal_widget/WishlistsManageApproversModalWidget"
        ),
});

export const SharedWishlistPageWidgetDefinition = defineModule({
    name: WISHLIST_WIDGET_NAMES.SHARED_WISHLIST_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "SharedWishlistPageWidget" */ "./widgets/shared_wishlist_page_widget/SharedWishlistPageWidget"
        ),
});

export const WishlistDrawerWidgetDefinition = defineModule({
    name: WISHLIST_WIDGET_NAMES.WISHLIST_DRAWER_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "WishlistDrawerWidget" */ "./widgets/wishlist_drawer_widget/WishlistDrawerWidget"
        ),
});

export const WishlistPageWidgetDefinition = defineModule({
    name: WISHLIST_WIDGET_NAMES.WISHLIST_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "WishlistPageWidget" */ "./widgets/wishlist_page_widget/WishlistPageWidget"
        ),
});

export const WishlistsWidgetDefinition = defineModule({
    name: WISHLIST_WIDGET_NAMES.WISHLISTS_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "WishlistsWidget" */ "./widgets/wishlists_widget/WishlistsWidget"
        ),
});

export const WishlistsItemsTotalCountInlineWidgetDefinition = defineModule({
    name: WISHLIST_WIDGET_NAMES.WISHLISTS_ITEMS_TOTAL_COUNT_INLINE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "WishlistsItemsTotalCountInlineWidget" */ "./widgets/wishlists_inline_widgets/wishlists_items_total_count_inline_widget/WishlistsItemsTotalCountInlineWidget"
        ),
});

export const SaveForLaterModalWidgetDefinition = defineModule({
    name: WISHLIST_WIDGET_NAMES.SAVE_FOR_LATER_MODAL_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "SaveForLaterModalWidget" */ "./widgets/save_for_later_button_widget/SaveForLaterModalWidget"
        ),
});
